const { scroll, animate, cubicBezier } = Motion;

const easing = cubicBezier(0.2, 0.3, 0.34, 0.86);

const shivaGate = document.getElementById("shiva-gate");
const shivaMain = document.getElementById("shiva-main");
const shivaMainText = document.getElementById("shiva-main-text");
const shivalinga = document.getElementById("shiva-main-shivalinga");
const shivaTrisul = document.getElementById("shiva-trisul");

// Helper: Responsive values for Shiva Gate Y animation
const getShivaGateY = () => {
  const viewportWidth = window.innerWidth;
  if (viewportWidth < 768) {
    return [0, -1000, -3000, -18000];
  } else if (viewportWidth <= 1024) {
    return [0, -2500, -4000, -12000];
  } else {
    return [0, -1300, -3500, -12000];
  }
};

// Helper: Responsive values for Shiva Main animation
const getShivaMainMarginTop = () => {
  return ["30dvh", 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
};

// Helper: Responsive values for Shiva Main Text animation
const getShivaMainTextValues = () => {
  const viewportWidth = window.innerWidth;
  if (viewportWidth < 768) {
    return {
      y: [
        300, -50, -50, -50, -50, -50, -50, -50, -50, -50, -50, -50, -50, -50,
        -50, -50, -50, -50, -50, -50, -50,
      ],
      opacity: [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      scale: [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
    };
  } else {
    return {
      opacity: [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      y: [
        360, -100, -100, -100, -100, -100, -100, -100, -100, -100, -100, -100,
        -100, -100, -100, -100, -100,

        -100, -100, -100, -100,
      ],
      scale: [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
    };
  }
};

// Helper: Responsive values for Shivalinga animation
const getShivalingaValues = () => {
  const viewportWidth = window.innerWidth;
  if (viewportWidth < 768) {
    return {
      y: [
        360,
        -60,
        -60,
        -60,
        -60,
        -60,
        -60,
        -60,
        -60,
        -60,
        -60,
        -60,
        -60,
        -60,
        -60,
        -60,
        -60,
        ,
        -60,
        -60,
        -60,
        -60,
      ],
      opacity: [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
    };
  } else {
    return {
      y: [450, -120, -120, -120, -120, -120, -120],
      opacity: [0, 1, 1, 1, 1],
    };
  }
};

// Helper: Responsive values for Shiva Trisul animation
const getShivaTrisulValues = () => {
  const viewportWidth = window.innerWidth;
  if (viewportWidth < 768) {
    return {
      y: [200, -50, -200],
      opacity: [0, 1, 1],
    };
  } else {
    return {
      y: [300, -50, -350],
      opacity: [0, 1, 1],
    };
  }
};

// Shiva Gate Animation
const animateShivaGate = () => {
  const shivaGateY = getShivaGateY();
  scroll(
    animate(shivaGate, {
      scale: [1, 70],
      y: shivaGateY,
    })
  );
};

// Shiva Main Animation
const animateShivaMain = () => {
  const marginTopValues = getShivaMainMarginTop();
  scroll(
    animate(
      shivaMain,
      {
        marginTop: marginTopValues,
      },
      { ease: easing }
    )
  );
};

// Shiva Main Text Animation
const animateShivaMainText = () => {
  const { y, opacity, scale } = getShivaMainTextValues();
  scroll(
    animate(
      shivaMainText,
      {
        y: y,
        opacity: opacity,
        scale: scale,
      },
      { ease: easing }
    )
  );
};

// Shivalinga Animation
const animateShivalinga = () => {
  const { y, opacity } = getShivalingaValues();
  scroll(
    animate(
      shivalinga,
      {
        y: y,
        opacity: opacity,
      },
      { ease: easing }
    )
  );
};

// Shiva Trisul Animation
const animateShivaTrisul = () => {
  const { y, opacity } = getShivaTrisulValues();
  scroll(
    animate(
      shivaTrisul,
      {
        y: y,
        opacity: opacity,
      },
      { ease: easing }
    )
  );
};

// Initialize Animations
const initializeAnimations = () => {
  animateShivaGate();
  animateShivaMain();
  animateShivaMainText();
  animateShivalinga();
  animateShivaTrisul();
};

// Call animations initially
initializeAnimations();

// Update animations on resize
window.addEventListener("resize", () => {
  initializeAnimations();
});
